module.exports = __webpack_public_path__ + "img/output.775af581.png";